<template>
  <MobileHeader :mobileHeaderTitle="'HKFC_SOCCER_SEVENS'"></MobileHeader>
  <div v-if="!isMobile && currentPage === 'hkfcMatches'">
    <!-- <Banner class="hkfc-banner"></Banner> -->
  </div>
  <div class="container hkfc-mobile__header hkfc-container">
    <div class="display-flex hkfc-nav__wrapper has-space nowrap overflow-x">
      <router-link
        :to="{ name: o.pathName }"
        class="sub-nav__child"
        v-for="(o, index) in tabs"
        :key="index"
      >
        <span class="sub-nav__child-text">{{ $t(o.name) }}</span>
        <div
          class="sub-nav__child-indicator"
          :class="{ 'nav-selected': o.name === currentPage }"
        ></div>
      </router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import MobileHeader from "@/components/mobile/Header.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Banner,
    MobileHeader,
  },
  data() {
    return {
      currentPage: "",
      tabs: [
        {
          name: "MATCHES",
          pathName: "sgfcMatches",
          selected: true,
        },
        {
          name: "BRACKET",
          pathName: "sgfcBracket",
          selected: false,
        },
      ],
    };
  },
  watch: {
    $route() {
      this.currentPage = this.$route.name;
    },
  },
  computed: {
    ...mapGetters([
      "isMobile",
      "currentLocale",
      "currentLanguageObj",
      "currentSportType",
    ]),
  },
  mounted() {
    this.currentPage = this.$route.name;

    if (this.isMobile) {
      let obj = {
        name: "STANDINGS",
        pathName: "sgfcStanding",
        selected: false,
      };
      this.tabs.splice(1, 0, obj);
    }
  },
  methods: {
    // ...mapActions(["getHkfcMatchLiveVideos"]),
  },
};
</script>

<style>
.hkfc-nav__wrapper {
  margin-bottom: 32px;
}
.hkfc-banner {
  margin-bottom: 40px;
}
/* .hkfc-container{
        margin-bottom: 40px;
    } */
@media (max-width: 1200px) {
  /* for test */
  .hkfc-mobile__header {
    padding-top: 5rem;
  }
}
</style>
